export default __webpack_public_path__ + "static/r520-render-2d46a5c2031b0fefd67d15dea4500515.png";